// @flow strict

import { ImagePreloaderRenderer } from '@ta/common.image-preloader';
import React, { type Node } from 'react';

type Props = {|
  renderLoading?: () => Node,
  url?: string,
|};

// http://davidmacd.com/blog/alternate-text-for-css-background-images.html
/** Loading component */
const Loading = ({ renderLoading, url }: Props) => {
  if (renderLoading === undefined) {
    return null;
  }
  return <ImagePreloaderRenderer url={url} delay={0} loadingRenderer={renderLoading} />;
};

export default Loading;
